'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _polyfills = require('./polyfills');

var _polyfills2 = _interopRequireDefault(_polyfills);

var _VideoProvider = require('./VideoProvider');

var _VideoProvider2 = _interopRequireDefault(_VideoProvider);

var _Video = require('./Video');

var _Video2 = _interopRequireDefault(_Video);

var _ProgressBar = require('./Components/ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

var _PlayPause = require('./Components/PlayPause');

var _PlayPause2 = _interopRequireDefault(_PlayPause);

var _Forward = require('./Components/Forward');

var _Forward2 = _interopRequireDefault(_Forward);

var _Backward = require('./Components/Backward');

var _Backward2 = _interopRequireDefault(_Backward);

var _SlowMotion = require('./Components/SlowMotion');

var _SlowMotion2 = _interopRequireDefault(_SlowMotion);

var _Fullscreen = require('./Components/Fullscreen');

var _Fullscreen2 = _interopRequireDefault(_Fullscreen);

var _NextItem = require('./Components/NextItem');

var _NextItem2 = _interopRequireDefault(_NextItem);

var _PreviousItem = require('./Components/PreviousItem');

var _PreviousItem2 = _interopRequireDefault(_PreviousItem);

var _SettingsMenu = require('./Components/SettingsMenu');

var _SettingsMenu2 = _interopRequireDefault(_SettingsMenu);

var _Time = require('./Components/Time');

var _Time2 = _interopRequireDefault(_Time);

var _Volume = require('./Components/Volume');

var _Volume2 = _interopRequireDefault(_Volume);

var _FastForward = require('./Components/FastForward');

var _FastForward2 = _interopRequireDefault(_FastForward);

var _FastRewind = require('./Components/FastRewind');

var _FastRewind2 = _interopRequireDefault(_FastRewind);

var _SlowRewind = require('./Components/SlowRewind');

var _SlowRewind2 = _interopRequireDefault(_SlowRewind);

var _RestartItem = require('./Components/RestartItem');

var _RestartItem2 = _interopRequireDefault(_RestartItem);

var _StreamSelector = require('./Components/StreamSelector');

var _StreamSelector2 = _interopRequireDefault(_StreamSelector);

var _Tooltip = require('./shared/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ResizeMonitor = require('./Components/ProgressBar/ResizeMonitor');

var _ResizeMonitor2 = _interopRequireDefault(_ResizeMonitor);

var _TimeSubscriber = require('./shared/TimeSubscriber');

var _store = require('./store');

var _publicActions = require('./store/actions/publicActions');

var _publicActions2 = _interopRequireDefault(_publicActions);

var _middleware = require('./store/migration/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _StreamRecord = require('./store/records/StreamRecord');

var _msToReadableString = require('./shared/msToReadableString');

var _msToReadableString2 = _interopRequireDefault(_msToReadableString);

var _connectWithContext = require('./connectWithContext');

var _connectWithContext2 = _interopRequireDefault(_connectWithContext);

var _hudlVideoPlayback = require('hudl-video-playback');

var _icon = require('./shared/styles/icon.css');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _polyfills2.default)(); /**
                             * Copyright 2013-2015, Hudl
                             * All rights reserved.
                             *
                             * This source code is licensed under the BSD-style license found in the
                             * LICENSE file in the root directory of this source tree. An additional grant
                             * of patent rights can be found in the PATENTS file in the same directory.
                             *
                             * @providesModule VideoInterface
                             */

// Redux Store items
exports.default = {
  viActions: _publicActions2.default,
  viReducers: _store.viReducers,
  setStoreInstance: _store.setStoreInstance,
  viMiddleware: _middleware2.default,

  VideoProvider: _VideoProvider2.default,
  Video: _Video2.default,
  Row: _Row2.default,
  PlayPause: _PlayPause2.default,
  Forward: _Forward2.default,
  Backward: _Backward2.default,
  SlowMotion: _SlowMotion2.default,
  Fullscreen: _Fullscreen2.default,
  FastForward: _FastForward2.default,
  FastRewind: _FastRewind2.default,
  SlowRewind: _SlowRewind2.default,
  RestartItem: _RestartItem2.default,
  PreviousItem: _PreviousItem2.default,
  SettingsMenu: _SettingsMenu2.default,
  NextItem: _NextItem2.default,
  ProgressBar: _ProgressBar2.default,
  Volume: _Volume2.default,
  Time: _Time2.default,
  StreamSelector: _StreamSelector2.default,
  TimeSubscriber: _TimeSubscriber.TimeSubscriber,
  TimeSubscriberPropTypes: _TimeSubscriber.TimeSubscriberPropTypes,
  Tooltip: _Tooltip2.default,
  StreamRecord: _StreamRecord.StreamRecord,
  ResizeMonitor: _ResizeMonitor2.default,

  utils: {
    connectWithContext: _connectWithContext2.default,
    msToReadableString: _msToReadableString2.default,
    VideoPlayerUtils: _hudlVideoPlayback.VideoPlayerUtils
  },

  viStyles: {
    icons: _icon2.default
  }
};
module.exports = exports['default'];